import { getQueryParamValue } from '../lib/browser';
import * as storage from '../lib/storage';

export const useImpactClickId = () => {
  const impactClickId = getQueryParamValue('irclickid');
  if (impactClickId) {
    storage.writeItem('impactClickId', impactClickId);
  }
};
